import { useLocation } from 'react-router-dom'

import { FormSuccess } from '../../../components/FormSuccess'
import PublicFormLayout from '../../../components/publicFormLayout/PublicFormLayout'
import { IExperienceFeedbackSummary } from '../../../services/ExperienceFeedback/interfaces'
import ExperienceFeedbackScore from './ExperienceFeedbackScore'

export default function ExperienceFeedbackCompletePage() {
  // Sent by the step page right after the last answer; absent on a direct reload.
  const { state } = useLocation()
  const summary = (state as { summary?: IExperienceFeedbackSummary } | null)?.summary

  return (
    <PublicFormLayout title="Avaliação de Experiência">
      <FormSuccess
        title="Avaliação de Experiência Concluída!"
        description="Obrigado pelo preenchimento Magenta!"
        notes={['#ABRACEVAI \\o/']}
        actions={[
          { label: 'Retornar para página inicial', to: '/experience-feedback', loggedOnly: true },
          { label: 'Realizar uma nova Avaliação de Experiência', to: '/experience-feedback/new' }
        ]}
      >
        {summary && <ExperienceFeedbackScore {...summary} />}
      </FormSuccess>
    </PublicFormLayout>
  )
}
